import React from 'react';
import { MuiGrid, MuiTypography, MuiInfoIcon } from '../ui/MaterialUIComponents';
import theme from '../../assests/theme'
const PageHeaderComponent = (props) => {
    return (<MuiGrid >
        {props.title != '' && <MuiGrid item xs={12} >
            <MuiGrid container item justify="flex-start" >
                <MuiTypography align="left" variant={theme.typographyStyles.H4} color='primary' gutterBottom>
                    {props.title}
                </MuiTypography>
                <MuiInfoIcon color="primary" size="small" onClick={(event) => props.showContextualHelp(props, event)} />
            </MuiGrid>
        </MuiGrid>}
        {props.subTitle != '' && <MuiGrid container alignItems='center' xs={12} >
            <MuiTypography align="left" variant={theme.typographyStyles.body} style={{ color: theme.palette.grey.darker, }}>
                {props.subTitle}   </MuiTypography> </MuiGrid>

        }

    </MuiGrid>)
}
export default PageHeaderComponent;